<div class="store-locator-page-template">
  <cx-page-slot position="StoreLocator" />
</div>

<ng-template cxOutletRef="StoreLocator">
  <wc-store-locator />
</ng-template>
